require('./helpers/bundle-manifest').register(JSON.parse("{\"f9fpV\":\"index.cc0b03b4.js\",\"eyyUD\":\"icons.c3496302.svg\"}"));